import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Icon } from '@codex-brightworld/icons';
import Link from '../Link/Link';

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.shades[7]};
  font-size : 12px;
  display: flex;
  flex-wrap: wrap;

  ${Link} {
    text-decoration: underline;
    margin-bottom: 10px;

    &:hover {
      text-decoration: none;
    }
  }

  > span {
    margin-bottom: 10px;
  }

  ${({ theme }) => css`
  color: ${theme.colors.shades[3]};
  border: 1px solid ${theme.colors.shades[5]};
  padding: ${theme.spacing[2]} ${theme.spacing[2]} 0 ${theme.spacing[2]};
  border-radius: ${theme.borderRadius ? theme.borderRadius[1] : 0};

  @media ${theme.breakpoints.mobile} {
    border-left : 0;
    border-right : 0;
  }`};

  ${Icon} {
    color: ${({ theme }) => theme.colors.shades[5]};
  }
`;

const Breadcrumbs = (props) => {

  const items = React.Children.toArray(props.children);
  const itemsCount = items.length;

  items.splice(itemsCount - 1, 1, <span {...items[itemsCount - 1].props} />);

  return (
    <Wrapper className={props.className} data-qa={props.qa}>
      {items.map((child, i) => (
        <Fragment key={i}>
          {child}
          {i < itemsCount - 1 && <> {props.separator} </>}
        </Fragment>
      ))}
    </Wrapper>
  );
};

Breadcrumbs.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  separator: PropTypes.node,
  qa: PropTypes.string
};

Breadcrumbs.defaultProps = {
  className: undefined,
  separator: <Icon icon="arrowright" />,
  qa: undefined
};

Breadcrumbs.displayName = 'Breadcrumbs';

/** @component */
export default Breadcrumbs;
